export const CAPABILITIES = Object.freeze({
  ADMIN: {
    ACTIVATION_MODE: {
      WRITE: 'admin:activation_mode:write',
    },
    BILLING: {
      WRITE: 'admin:billing:write',
    },
    CLIENT: {
      LOGOUT: 'admin:client:logout',
    },
    CLIENTS: {
      DELETE: 'admin:clients:delete',
      READ: 'admin:clients:read',
      WRITE: 'admin:clients:write',
    },
    CLIENT_FEATURE_GROUP: {
      READ: 'admin:client_feature_group:read',
      WRITE: 'admin:client_feature_group:write',
    },
    CLIENT_PROVIDER: {
      WRITE: 'admin:client_provider:write',
    },
    CLIENT_VCARD: {
      SEND: 'admin:client_vcards:send',
    },
    CUSTOM_DOMAIN: {
      WRITE: 'admin:custom_domain:write',
    },
    CUSTOM_FROST: {
      WRITE: 'admin:custom_frost:write',
    },
    FANS: {
      WRITE: 'admin:fans:write',
    },
    FEATURE_GROUP: {
      READ: 'admin:feature_group:read',
      WRITE: 'admin:feature_group:write',
    },
    NUMBER_IMPORT: {
      WRITE: 'admin:number_import:write',
    },
    NUMBER_PROVISIONING: {
      WRITE: 'admin:number_provisioning:write',
    },
    PROTECTED_ROLE_SEAT: {
      WRITE: 'admin:protected_seats:write',
    },
    PROTECTED_TAGS: {
      WRITE: 'admin:protected_tags:write',
    },
    RESTRICTED_REGISTRATION_FIELD: {
      WRITE: 'admin:restricted_registration_field:write',
    },
    ROLES: {
      READ: 'admin:roles:read',
    },
    SEGMENT_BILLING: {
      WRITE: 'admin:segment_billing:write',
    },
    SSO_CONFIGS: {
      READ: 'admin:sso_configs:read',
      WRITE: 'admin:sso_configs:write',
    },
    TAG_LIMIT: {
      WRITE: 'admin:tag_limit:write',
    },
    TCR_REGISTRATION: {
      WRITE: 'admin:tcr_registration:write',
    },
    UNSUPPORTED_STATE_CODES: {
      WRITE: 'admin:unsupported_state_codes:write',
    },
    WHITE_LABEL_ENABLED: {
      WRITE: 'admin:white_label_enabled:write',
    },
  },
  FEATURE: {
    AMB: {
      ALL: 'feature:amb:all',
    },
    CAMPAIGN_COST_ESTIMATION: {
      ALL: 'feature:campaign_cost_estimation:all',
    },
  },
  GLOBAL: {
    ADMIN: {
      ALL: 'global:admin:all',
    },
    ROLE: {
      WRITE: 'global:role:write',
    },
  },
} as const)
